<div class="flxRow gap-2 animated fadeIn" style="align-items: center; flex-wrap: wrap;"
	 (click)="$event.stopPropagation();">
	<div class="flxRow gap-3" style="align-items: flex-end;">

		<!-- Comparison period -->
		<div class="flxClmn gap-1">
			<span class="fw-500 opacity-75" style="font-size: 11px; white-space: nowrap;">Comparison period</span>
			<app-dropdown-c style="width: 130px;"
							[text]="comparisonService.granularity | titlecase"
							[items]="granularityOptions"
							[isDisabled]="comparisonService.comparisonLoading"
							(onItemClicked)="onGranularityChange($event.item);">
			</app-dropdown-c>
		</div>

		<span class="opacity-50 p-1 ps-0" style="font-size: 20px; font-weight: 200;">|</span>

		<!-- Back arrow -->
		<btn-c variant="text" style="min-width: 0; padding: 0;"
			   [isDisabled]="comparisonService.comparisonLoading"
			   (action)="shiftBothPeriods(-1);">
			<i class="far fa-chevron-left"></i>
		</btn-c>

		<!-- Current period -->
		<div class="flxClmn gap-1">
			<span class="fw-500 opacity-75" style="font-size: 11px; white-space: nowrap;">Current period</span>
			<custom-date-picker-c style="width: 185px;"
								  [style.pointer-events]="comparisonService.comparisonLoading ? 'none' : ''"
								  [dateModel]="comparisonService.currentPeriodDate"
								  (dateModelChange)="onCurrentDateChange($event)"
								  [dateView]="comparisonService.granularity === 'monthly' ? 'Month' : comparisonService.granularity === 'weekly' ? 'Week' : 'Day'">
			</custom-date-picker-c>
		</div>

		<!-- Compared to -->
		<div class="flxClmn gap-1">
			<span class="fw-500 opacity-75" style="font-size: 11px; white-space: nowrap;">Compared to</span>
			<custom-date-picker-c style="width: 185px;"
								  [style.pointer-events]="comparisonService.comparisonLoading ? 'none' : ''"
								  [dateModel]="comparisonService.comparedPeriodDate"
								  (dateModelChange)="onComparedDateChange($event)"
								  [dateView]="comparisonService.granularity === 'monthly' ? 'Month' : comparisonService.granularity === 'weekly' ? 'Week' : 'Day'">
			</custom-date-picker-c>
		</div>

		<!-- Forward arrow -->
		<btn-c variant="text" style="min-width: 0; padding: 0;"
			   [isDisabled]="forwardDisabled || comparisonService.comparisonLoading"
			   (action)="shiftBothPeriods(1);">
			<i class="far fa-chevron-right"></i>
		</btn-c>

		<span class="opacity-50 p-1 ps-0" style="font-size: 20px; font-weight: 200;">|</span>

		<btn-c endIcon="zmdi zmdi-check"
			   [loading]="comparisonService.comparisonLoading"
			   (action)="confirmComparison();">
			Compare
		</btn-c>
	</div>

	<div class="flxRow gap-2 animated fadeIn" style="align-items: center; background: var(--ui-surface-2); border-radius: 999px; padding: 3px 6px 3px 12px;"
		 *ngIf="comparisonService.comparisonLoading">
		<i class="far fa-spin fa-spinner" style="color: var(--ui-brand); font-size: 12px;"></i>
		<span style="font-weight: 500; color: var(--ui-text-muted); white-space: nowrap;">Processing</span>
		<span *ngIf="comparisonService.comparisonProgressPercent" style="font-weight: 600; color: var(--ui-text); min-width: 34px;">{{comparisonService.comparisonProgressPercent}}%</span>
		<div *ngIf="comparisonService.comparisonProgressPercent" style="width: 80px; height: 4px; border-radius: 999px; background: var(--ui-border); overflow: hidden;">
			<div style="height: 100%; border-radius: 999px; background: var(--ui-brand); transition: width 0.3s;" [style.width.%]="comparisonService.comparisonProgressPercent"></div>
		</div>
		<btn-c variant="text" color="danger"
			   style="min-width: 0;"
			   (action)="comparisonService.abortComparisonBatches();">
			Abort
		</btn-c>
	</div>
</div>
